import type { components } from '@/generated/internal-api/openapi-types';
import { _notNil } from '@/littledash';

export type CascadeDeleteChildType = 'samples' | 'measurements' | 'observations' | 'dosages';

export type CascadeDeleteOptions = Record<CascadeDeleteChildType, boolean>;

export type CascadeDeleteItemCounts = components['schemas']['AnimalCascadeDeleteItemCountV1'];

export interface CageCascadeDeleteOptions extends CascadeDeleteOptions {
  animals: boolean;
}

export type StudyCascadeDeleteOptions = components['schemas']['StudyCascadeDeleteOptionsV1'];

export type StudyCascadeDeleteFlag = keyof StudyCascadeDeleteOptions;

export type CascadeDeleteParentType = 'animal' | 'cage' | 'study';

export type CascadeDeleteSelection = CascadeDeleteOptions &
  Partial<Pick<CageCascadeDeleteOptions, 'animals'>> &
  Partial<Pick<StudyCascadeDeleteOptions, 'cages' | 'groups' | 'treatments' | 'diseases'>>;

export const CASCADE_DELETE_CHILD_OPTIONS: Array<[CascadeDeleteChildType, string]> = [
  ['samples', 'Samples'],
  ['measurements', 'Measurements'],
  ['observations', 'Observations'],
  ['dosages', 'Dosages'],
];

export const STUDY_CASCADE_DELETE_OPTIONS: Array<[StudyCascadeDeleteFlag, string]> = [
  ['cages', 'Cages'],
  ['animals', 'Animals'],
  ['samples', 'Samples'],
  ['groups', 'Groups'],
  ['treatments', 'Treatments'],
  ['diseases', 'Diseases'],
  ['measurements', 'Measurements'],
  ['observations', 'Observations'],
  ['dosages', 'Dosages'],
];

export const UNCHECKED_CASCADE_DELETE_OPTIONS: CascadeDeleteOptions = {
  samples: false,
  measurements: false,
  observations: false,
  dosages: false,
};

export const EMPTY_CASCADE_DELETE_ITEM_COUNTS: CascadeDeleteItemCounts = {
  samples: 0,
  measurements: 0,
  observations: 0,
  dosages: 0,
};

export const hasSelectedCascadeOption = (cascade?: CascadeDeleteOptions): boolean =>
  _notNil(cascade) && CASCADE_DELETE_CHILD_OPTIONS.some(([name]) => cascade[name]);

export const UNCHECKED_CAGE_CASCADE_DELETE_OPTIONS: CageCascadeDeleteOptions = {
  animals: false,
  ...UNCHECKED_CASCADE_DELETE_OPTIONS,
};

export const UNCHECKED_STUDY_CASCADE_DELETE_OPTIONS: StudyCascadeDeleteOptions = {
  cages: false,
  groups: false,
  treatments: false,
  diseases: false,
  ...UNCHECKED_CAGE_CASCADE_DELETE_OPTIONS,
};
